import Vue from 'vue'
import Vuex from 'vuex'
 
import apple from './apple' 
import errors from './errors' 
import items from './items' 
import load from './load'
import mbs from './mbs'
import users from './users/index' 
import not  from './not'
import locationDetails from './locationDetails'
import time from './time' 
import geoJson from './geoJson' 
//import geoJson2 from './geoJson2' 
import join from './join' 
import {conductor} from "../plugins/CONDUCTOR"


Vue.use(Vuex)

export const store = new Vuex.Store({ 
  modules:{
    apple:apple,  
    errors:errors,  
    not: not ,
    locationDetails: locationDetails,
    load: load,
    mbs: mbs,
    users: users,
    items:items,  
    time:time, 
    geoJson:geoJson, 
    //geoJson2:geoJson2, 
    join:join,
  },
  plugins:[conductor]
  
})